function PlusIcon() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 2V38" stroke="white" strokeWidth="3.27273" strokeLinecap="round"/>
            <path d="M2 20L38 20" stroke="white" strokeWidth="3.27273" strokeLinecap="round"/>
        </svg>
    );
}

export default PlusIcon;
